import Vue from 'vue'
import Router from 'vue-router'

import { publicRoutes } from './public_routes'

import CreateProfilePhoto from '@/containers/individual_profile/CreateProfilePhoto'

import CreateBusinessProfile from '@/containers/business_profile/CreateBusinessProfile'
import CreateBusinessProfilePhoto from '@/containers/business_profile/CreateBusinessProfilePhoto'
import CreateBusinessProfileInfo from '@/containers/business_profile/CreateBusinessProfileInfo'
import CreateBusinessProfileAddress from '@/containers/business_profile/CreateBusinessProfileAddress'
import CreateBusinessProfileInstructions from '@/containers/business_profile/CreateBusinessProfileInstructions'
import CreateBusinessAgreements from '@/containers/business_profile/CreateBusinessAgreements'

import CreatePass from '@/containers/create/CreatePass'

import Dashboard from '@/containers/Dashboard'
import Passes from '@/containers/dashboard/Passes'
import Agreements from '@/containers/dashboard/Agreements'
import Profile from '@/containers/dashboard/Profile'
import Roles from '@/containers/dashboard/Roles'

import PassView from '@/containers/passes/PassDetailView'
import PassInvite from '@/containers/passes/PassInvite'

import CreateAgreement from '@/containers/agreements/CreateAgreement'
import ViewAgreements from '@/containers/agreements/ViewAgreements'
import EditAgreement from '@/containers/agreements/EditAgreement'

import ShareView from '@/containers/share/ShareView'
import PassShare from '@/containers/share/passes/BasePassShare'

import ScanPass from '@/containers/ScanPass'

import { AuthService } from '../api/AuthService'
const auth = new AuthService

Vue.use(Router)

const routes = [
  ...publicRoutes,
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else next()
    },
    redirect: to => {
      // the function receives the target route as the argument
      // return redirect path/location here.
      // if(auth.getAccountType() === 'business') return '/dashboard/passes'
      // else return '/dashboard/cards'
      return '/dashboard/passes'
    },
    children: [
      { path: 'passes', component: Passes },
      { path: 'agreements', component: Agreements },
      { path: 'profile', component: Profile },
      { path: 'roles', component: Roles }
    ]
  },
  {
    path: '/upload-selfie',
    name: 'CreateProfilePhoto',
    component: CreateProfilePhoto,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) {
        next({ path: '/login' })
      } else {
        if(auth.getAccountType() !== 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  {
    path: '/create-profile/business/:id',
    component: CreateBusinessProfile,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    },
    children: [
      { path: 'info', component: CreateBusinessProfileInfo },
      { path: 'photo', component: CreateBusinessProfilePhoto },
      { path: 'address', component: CreateBusinessProfileAddress },
      { path: 'instructions', component: CreateBusinessProfileInstructions },
      { path: 'agreements', component: CreateBusinessAgreements },
    ]
  },
  {
    path: '/create-pass',
    name: 'CreatePass',
    component: CreatePass,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  {
    path: '/agreements/create',
    name: 'CreateAgreement',
    component: CreateAgreement,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  {
    path: '/agreements/edit/:id',
    name: 'EditAgreement',
    component: EditAgreement,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  {
    path: '/passes/:id',
    name: 'PassDetailView',
    component: PassView,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  {
    path: '/passes/:id/invites',
    name: 'PassInvite',
    component: PassInvite,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) next({ path: '/login' })
      else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  },
  // shared children
  {
    path: '/invite',
    component: ShareView,
    children: [
      // { path: 'cards/:link_id', name: 'InviteCards', component: CardShare },
      { path: 'passes/:link_id', name: 'InvitePasses', component: PassShare },
    ]
  },
  {
    path: '/agreements/view/:agid',
    name: 'ViewAgreements',
    component: ViewAgreements,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) {
        next({ path: '/login' })
      } else {
        next()
      }
    }
  },
  {
    path: '/scan-pass',
    name: 'ScanPass',
    component: ScanPass,
    beforeEnter: (to, from, next) => {
      if (!auth.isAuthenticated()) {
        next({ path: '/login' })
      } else {
        if(auth.getAccountType() === 'individual') next({ path: '/dashboard' })
        else next()
      }
    }
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkExactActiveClass: 'is-active'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js